import { render, staticRenderFns } from "./upLoadImg.vue?vue&type=template&id=68f54520&scoped=true&"
import script from "./upLoadImg.vue?vue&type=script&lang=js&"
export * from "./upLoadImg.vue?vue&type=script&lang=js&"
import style0 from "./upLoadImg.vue?vue&type=style&index=0&id=68f54520&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f54520",
  null
  
)

export default component.exports